/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types'

// @mui material components
import Icon from '@mui/material/Icon'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import { useMemo, memo } from 'react'

const LinkCell = memo(({ name, link, openInNewTab = false }) => {
  const newTabProps = useMemo(
    () =>
      openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {},
    [openInNewTab]
  )
  return (
    <SoftBox>
      <SoftTypography
        component="a"
        href={link}
        variant="button"
        fontWeight="medium"
        sx={({ palette: { secondary }, typography: { size } }) => ({
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#2152ff',

          '& .material-icons-round': {
            ml: 0.5,
            fontSize: size.md,
            transition: 'transform 0.2s cubic-bezier(0.34,1.61,0.7,1.3)',
          },

          '&:hover .material-icons-round': {
            transform: 'translateX(5px)',
            color: '#344767',
          },
          '&:hover': {
            color: '#344767',
          },
        })}
        {...newTabProps}
      >
        {name} <Icon sx={{ fontWeight: 'bold' }}>arrow_forward</Icon>
      </SoftTypography>
    </SoftBox>
  )
})

LinkCell.displayName = 'LinkCell'
// Setting default value for the props of LinkCell
LinkCell.defaultProps = {
  link: '#',
}

// Typechecking props for the LinkCell
LinkCell.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
}

export default LinkCell
